import { createSelector } from "reselect"
import { selectActionCenterIdFromRouteOrProp } from "grassroots/selectors/action-center-selectors"

const selectGrassroots = (state, _) => state.grassroots

const selectActionCenters = createSelector(selectGrassroots, (grassroots) => grassroots.get("actionCenters"))

const createActionCentersPropertySelector = (property) =>
    createSelector(selectActionCenters, (actionCenters) => actionCenters && actionCenters.get(property))

const selectActionCentersItems = createActionCentersPropertySelector("items")

export const selectActionCentersList = createSelector(selectActionCentersItems, (actionCenters) =>
    actionCenters ? Object.values(actionCenters.toJS()) : [],
)

export const selectActionCentersGamified = createSelector(selectActionCentersList, (actionCenters) =>
    actionCenters.filter((actionCenter) => actionCenter.gamification_enabled),
)

export const selectActionCentersPacClassicSites = createSelector(
    selectActionCentersList,
    selectActionCenterIdFromRouteOrProp,
    (actionCenters, actionCenterId) =>
        actionCenters.filter((ac) => ac.id === +actionCenterId)[0]?.pac_classic_sites || [],
)
